import PropTypes from 'prop-types';

import React, { useState } from 'react';
import { Card, Col, Row } from 'react-bootstrap';

import useToken from 'hooks/useToken';
import { useEffect } from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { useToast } from 'context/providers/ToastProvider';

const AvanceVentaItemsTrimestre = ({
    mes,
    idUsuario
}) => {
    const [cargando, setCargando] = useState(true);
    const { token, idCatTipoUsuario, setToken } = useToken();
    const { showErrorToast } = useToast();
    const [ventasTrim, setVentasTrim] = useState({});
    const [variablesMetasControl, setVariablesMetasControl] = useState({});


    const ObtenerItemsVendidosTrimestre = async (date_, idUsuario) => {
        console.log("date_: ", date_);
        setCargando(true);
        const response = await fetch("/api/home/ObtenerItemsVendidosTrimestre?idUsuario=" + idUsuario + "&date=" + date_, {
            method: 'GET',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        })
            .catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch: ' + error);
                console.log('Hubo un problema con la peticion Fetch: ' + error.message);

            });

        if (response.ok) {
            console.log(response);
            const data = await response.json();
            console.log(data);

            if (data['table1'][0].iResponseType == 1) {

                //Items del Mes
                setVentasTrim(data['table2'][0]);
                setVariablesMetasControl(data['table3'][0])
            }
            else {
                showErrorToast(data['table1'][0].vMessage);
            }

        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            console.log(response);

            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
        setCargando(false);

    };

    useEffect(() => {
        ObtenerItemsVendidosTrimestre(mes, idUsuario)
    }, [idUsuario, mes])

    return (
        <Card className="mb-3">
            <Card.Header>
                <Col>
                    <Row>
                        <Col className="col-12">
                            <h5><img src="/img/items48.png"></img> Your Quarterly Items:
                                {
                                    (cargando || variablesMetasControl.trimestre == null) ?
                                        <Skeleton />
                                        :
                                        <strong>
                                            {" " + (variablesMetasControl.trimestre.split('-'))[0] + " " + (variablesMetasControl.trimestre.split('-'))[1] + " " + (variablesMetasControl.trimestre.split('-'))[2] + " " + (variablesMetasControl.trimestre.split('-'))[3]}
                                        </strong>
                                }
                            </h5>
                        </Col>
                    </Row>
                </Col>
            </Card.Header>
            <Card.Body>
                <Row className="g-0">
                    <Col xs={6} sm={4} md={3} xl={3} xxl={2} className="align-items-center text-center border-300 border-end" >
                        <h6 className="pb-0 text-700">
                            LIC-SERV
                        </h6>
                        <span className={
                            'font-sans-serif fs-2 ' + (ventasTrim.iLicServ > 0 ? 'text-success' : 'text-danger')
                        }>
                            {cargando ? <Skeleton className="w-75" /> : ventasTrim.iLicServ}
                        </span>
                        <div>
                            <h6 className="fs--1 text-500 mb-0 ">

                                {cargando ? <Skeleton className="w-75" /> :
                                    idCatTipoUsuario == 1 ?
                                        <span>
                                            ${parseFloat(ventasTrim.dLicServSubtotal).toLocaleString("es-MX", {
                                                maximumFractionDigits: 2,
                                                minimumFractionDigits: 2
                                            })}
                                        </span>
                                        : <span></span>
                                }

                            </h6>
                        </div>
                    </Col>
                    <Col xs={6} sm={4} md={3} xl={3} xxl={2} className="align-items-center text-center border-300 border-end" >
                        <h6 className="pb-0 text-700">
                            LIC-CAJ
                        </h6>
                        <span className={
                            'font-sans-serif fs-2 ' + (ventasTrim.iLicCaj > 0 ? 'text-success' : 'text-danger')
                        }>
                            {cargando ? <Skeleton className="w-75" /> : ventasTrim.iLicCaj}
                        </span>
                        <div>
                            <h6 className="fs--1 text-500 mb-0 ">
                                {cargando ? <Skeleton className="w-75" /> :
                                    idCatTipoUsuario == 1 ?
                                        <span>
                                            ${parseFloat(ventasTrim.dLicCajSubtotal).toLocaleString("es-MX", {
                                                maximumFractionDigits: 2,
                                                minimumFractionDigits: 2
                                            })}
                                        </span>
                                        : <span></span>
                                }
                            </h6>
                        </div>
                    </Col>
                    <Col xs={6} sm={4} md={3} xl={3} xxl={2} className="align-items-center text-center border-300 border-end" >
                        <h6 className="pb-0 text-700">
                            P&Oacute;LIZAS
                        </h6>
                        <span className={
                            'font-sans-serif fs-2 ' + (ventasTrim.iPoliza > 0 ? 'text-success' : 'text-danger')
                        }>
                            {cargando ? <Skeleton className="w-75" /> : ventasTrim.iPoliza}
                        </span>
                        <div>
                            <h6 className="fs--1 text-500 mb-0 ">
                                {cargando ? <Skeleton className="w-75" /> :
                                    idCatTipoUsuario == 1 ?
                                        <span>
                                            ${parseFloat(ventasTrim.dPolizaSubtotal).toLocaleString("es-MX", {
                                                maximumFractionDigits: 2,
                                                minimumFractionDigits: 2
                                            })}
                                        </span> :
                                        <span></span>
                                }
                            </h6>
                        </div>
                    </Col>

                    <Col xs={6} sm={4} md={3} xl={3} xxl={2} className="align-items-center text-center border-300 border-end" >
                        <h6 className="pb-0 text-700">
                            LIC-NUB
                        </h6>
                        <span className={
                            'font-sans-serif fs-2 ' + (ventasTrim.iLicNub > 0 ? 'text-success' : 'text-danger')
                        }>
                            {cargando ? <Skeleton className="w-75" /> : ventasTrim.iLicNub}
                        </span>
                        <div>
                            <h6 className="fs--1 text-500 mb-0 ">
                                {cargando ? <Skeleton className="w-75" /> :
                                    idCatTipoUsuario == 1 ?
                                        <span>
                                            ${parseFloat(ventasTrim.dLicNubSubtotal).toLocaleString("es-MX", {
                                                maximumFractionDigits: 2,
                                                minimumFractionDigits: 2
                                            })}
                                        </span>
                                        :
                                        <span></span>
                                }
                            </h6>
                        </div>
                    </Col>
                    <Col xs={6} sm={4} md={3} xl={3} xxl={2} className="align-items-center text-center border-300 border-end" >
                        <h6 className="pb-0 text-700">
                            LIC-NUB-R
                        </h6>
                        <span className={
                            'font-sans-serif fs-2 ' + (ventasTrim.iLicNubRenov > 0 ? 'text-success' : 'text-danger')
                        }>
                            {cargando ? <Skeleton className="w-75" /> : ventasTrim.iLicNubRenov}
                        </span>
                        <div>
                            <h6 className="fs--1 text-500 mb-0 ">
                                {cargando ? <Skeleton className="w-75" /> :
                                    idCatTipoUsuario == 1 ?
                                        <span>
                                            ${parseFloat(ventasTrim.dLicNubRenovSubtotal).toLocaleString("es-MX", {
                                                maximumFractionDigits: 2,
                                                minimumFractionDigits: 2
                                            })}
                                        </span>
                                        : <span></span>
                                }
                            </h6>
                        </div>
                    </Col>

                </Row>
            </Card.Body>
        </Card>
    );
};

AvanceVentaItemsTrimestre.propTypes = {
    idUsuario: PropTypes.number,
    mes: PropTypes.instanceOf(Date)
};

export default AvanceVentaItemsTrimestre;
